module.exports = __webpack_public_path__ + "static/media/Technical-Writing-Sample.71996e20.pdf";